import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'page-payments_type',
  templateUrl: 'payments_type.html',
})
export class PaymentsType {
  @Input() payment_type;

  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/payments_type/payments_type.ts